import Typography from '@mui/material/Typography';
import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import Prompt from '../../Prompt/Prompt';

import {
  TXTCLI_Please_enter_your_phone_number_ELL_2,
  TXTSRV_Please_enter_your_phone_number_ELL,
  TXTWCL_Okay,
  TXTWCL_Please_enter_your_phone_number_ELL,
  TXTWCL_There_has_been_an_issue_with_y_ELL
} from './MobilePhoneValidationErrors.messages.json';

interface Props {
  onClose(): void;
}

const DE_MOBILE_PHONE_EXAMPLE = 493012345678;

const MobilePhoneValidationErrors: React.FC<Props> = ({ onClose }) => {
  const siteId = useSelector(select.cms.getSiteId);

  let bodyMessage;

  switch (siteId) {
    case Sites.DE:
      bodyMessage = (
        <Typography>
          <Translation
            values={{ 0: DE_MOBILE_PHONE_EXAMPLE }}
            {...TXTSRV_Please_enter_your_phone_number_ELL}
          />
        </Typography>
      );
      break;
    case Sites.CA_ON:
      bodyMessage = (
        <Typography>
          <Translation {...TXTWCL_Please_enter_your_phone_number_ELL} />
        </Typography>
      );
      break;
    default:
      bodyMessage = (
        <Typography>
          <Translation {...TXTCLI_Please_enter_your_phone_number_ELL_2} />
        </Typography>
      );
  }

  return (
    <Prompt
      onClose={onClose}
      variant="default"
      title={{ translation: TXTWCL_There_has_been_an_issue_with_y_ELL }}
      onPrimaryButtonClick={onClose}
      primaryButton={{ translation: TXTWCL_Okay }}
    >
      {bodyMessage}
    </Prompt>
  );
};

export default MobilePhoneValidationErrors;
